import { ThemeUICSSObject } from '@apia/theme';
import entity from './entity';
/* IMPORT HERE */

const execution: ThemeUICSSObject = {
  entity,
  /* PREPEND HERE */
};

export default execution;
